/**
 * common
 *
 * @author Shigq
 * @date 2020/12/10 10:24
 */
import http from '@/utils/http'
import { common } from '@/api/url'
import countryCode from './countryCode'

export function uploadFile(param) {
  return http({
    url: common.uploadFile,
    method: 'post',
    data: { ...param }
  })
}
export function growUploadFile(param) {
  return http({
    url: common.growUploadFile,
    method: 'post',
    data: { ...param }
  })
}

export function listCountryCode(param) {
  return countryCode.rspBody
  // return http({
  //   url: common.listCountryCode,
  //   method: 'post',
  //   data: param
  // })
}

export function listCurrency(param) {
  return http({
    url: common.listCurrency,
    method: 'post',
    data: param
  })
}

export function getFilePath(param) {
  return http({
    url: common.getFilePath,
    method: 'post',
    data: { ...param }
  })
}
export function growGetFileInfo(param) {
  return http({
    url: common.growGetFileInfo,
    method: 'post',
    data: { ...param }
  })
}

export function listDictionaryMapping(param) {
  return http({
    url: common.listDictionaryMapping,
    method: 'post',
    data: param,
    showErrMsg: false
  })
}
export function clientCountryCode(param) {
  return http({
    url: common.clientCountryCode,
    method: 'post',
    data: param,
    showErrMsg: false
  })
}